import React, { useCallback, useEffect, useState } from "react";
import { useToggleState } from "../use-toggle-state";

type Return = {
  isInViewport: boolean;
  ref: React.RefCallback<HTMLElement>;
};

export const useInViewport = (): Return => {
  const { toggle: isInViewport, toggleOn: setIsInViewport } = useToggleState();
  const [refElement, setRefElement] = useState<HTMLElement | null>(null);

  const setRef = useCallback((node: HTMLElement | null) => {
    if (node !== null) {
      setRefElement(node);
    }
  }, []);

  useEffect(() => {
    if (refElement && !isInViewport) {
      const observer = new IntersectionObserver(
        ([entry]) => entry.isIntersecting && setIsInViewport()
      );

      observer.observe(refElement);

      return () => {
        observer.disconnect();
      };
    }
  }, [isInViewport, refElement]);

  return { isInViewport, ref: setRef };
};
